// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BHb7n","textarea":"styles_textarea__29Aqs"};